import CpaStatistics from "./cpa_statistics/index.vue"
import TariffInvoices from "./invoices/index.vue"
import TariffsAndPayments from "./index.vue"
// import TariffPlans from './plans/index.vue'

export default {
  path: "/tariffs",
  name: "tariffs",
  component: TariffsAndPayments,
  children: [
    // В SNT-6725 приховано історію тарифів, залишена сторінка та компоненти для майбутніх оновлень
    // {
    //   path: 'history',
    //   name: 'tariffsHistory',
    //   component: TariffsHistory,
    //   meta: {
    //     title: 'tariffs.history.title'
    //   }
    // },
    {
      path: "invoices",
      name: "tariffInvoices",
      component: TariffInvoices,
      meta: {
        title: "tariffs.invoices.title"
      }
    },
    {
      path: "cpa_statistics",
      name: "cpaStatistics",
      component: CpaStatistics,
      meta: {
        title: "tariffs.cpa_statistics.title"
      }
    }
  ]
}
